import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";
import cat_model from "@iscr/models/cat_model";
import { isDefined } from "@iscr/helpers/isDefined";
export const WEIGHT_LOSS_SUBSCRIPTION_CATALOG = "/-N0VodZDRyHfr2XAqiV7/i/SubConsWL/i/";
// Path to navigate the tree
const WL_SUB_ANCESTOR_PATH = WEIGHT_LOSS_SUBSCRIPTION_CATALOG.slice(1).split("/i/");
export function getWeightLossSubscriptionMinPrice(cat_data) {
    var _a;
    if (!cat_data) {
        return undefined;
    }
    const { cat_tree_list, meds_mb_list } = cat_data;
    // The subscription medication ancestor nodes are "active: false", so they're filtered from the cat_avail_list.
    // Drill into the raw tree data to retrieve them.
    let catalogue = cat_tree_list;
    for (const key of WL_SUB_ANCESTOR_PATH) {
        if (key) {
            catalogue = (_a = catalogue === null || catalogue === void 0 ? void 0 : catalogue[key]) === null || _a === void 0 ? void 0 : _a.i;
        }
    }
    const prices = Object.entries(catalogue !== null && catalogue !== void 0 ? catalogue : {})
        .filter(([, item]) => item.t === "m")
        .map(([key]) => { var _a; return (_a = meds_mb_list === null || meds_mb_list === void 0 ? void 0 : meds_mb_list[key]) === null || _a === void 0 ? void 0 : _a.medbuy_price; })
        .filter(isDefined);
    return prices.length === 0 ? undefined : Math.min(...prices);
}
export function useWeightLossSubscriptionMinPrice(cat_data) {
    const fetched = useAsync({
        // If cat_data is supplied, avoid an unnecessary fetch
        immediate: !cat_data,
        fn: () => cat_model.get_cat_list({ cat_nm: "pharm", mb_list: "pharm" }),
    }, []);
    return getWeightLossSubscriptionMinPrice(cat_data !== null && cat_data !== void 0 ? cat_data : fetched.data);
}
